import { render, staticRenderFns } from "./novel_extension.vue?vue&type=template&id=8fe66e7c&scoped=true&"
import script from "./novel_extension.vue?vue&type=script&lang=js&"
export * from "./novel_extension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe66e7c",
  null
  
)

export default component.exports